<div class="container-fluid p-v-80">
  <div class="d-flex flex-column justify-content-between">
    <div class="d-none d-md-block p-h-40">
      <img class="img-fluid" alt="" src="assets/images/logo/logo.png" loading="eager">
    </div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-5">
          <div class="p-v-30">
            <h2 class="font-weight-light font-size-30">Whoops! Looks like you got lost</h2>
            <p class="lead m-b-30">Sorry, we couldn't find what you were looking for</p>
            <a class="go-back-button" (click)="goBack()" nz-button nzType="primary">Go Back</a>
          </div>
        </div>
        <div class="col-md-6 m-l-auto">
          <img class="img-fluid" src="assets/images/others/error-1.webp" alt="Error">
        </div>
      </div>
    </div>
  </div>
</div>
